module.exports = __webpack_public_path__ + "img/team.78bea9d4.png";